import React from 'react';

// Renders the original landing-page HTML exactly one-to-one.
// The file lives in /public/madrich-b.html and is embedded full-screen
// so it is served untouched, byte-for-byte as provided.
const GuideB = () => (
  <iframe
    title="חבילת הדירה החכמה"
    src={`${process.env.PUBLIC_URL}/madrich-b.html`}
    style={{
      position: 'fixed',
      inset: 0,
      width: '100%',
      height: '100%',
      border: 'none',
    }}
  />
);

export default GuideB;
